/* Good Travel · Presupuesto: salida (desde dónde), campos obligatorios y freno a bots */
(function () {
'use strict';
var root = document.getElementById('gtq');
if (!root || root.dataset.origen) return;
root.dataset.origen = '1';
var KEY = 'gtq-origen';
function $(s) { return root.querySelector(s); }
function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
function store(v) { try { if (v === undefined) return sessionStorage.getItem(KEY); sessionStorage.setItem(KEY, v); } catch (e) { return null; } }
function code(txt) { var m = String(txt || '').match(/\(([A-Za-z]{3})\)/); return m ? m[1].toUpperCase() : String(txt || '').trim().slice(0, 3).toUpperCase(); }

/* Página de éxito: muestra la salida en la tarjeta */
if ($('[data-done]')) {
  var saved = store();
  var t = $('[data-t-from]');
  if (saved && t) t.textContent = code(saved);
  return;
}
var form = root.querySelector('form');
if (!form) return;

var loaded = Date.now(), touches = 0, budgetTouched = false;
['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { touches++; }, { passive: true }); });

/* Salida */
var from = $('[data-from]'), hidden = $('[data-f="origen"]'), sum = $('[data-sum-from]');
function setFrom(v) {
  v = String(v || '').trim();
  if (hidden) hidden.value = v;
  if (sum) { sum.textContent = v ? v.replace(/\s·\s.*$/, '') : 'Por elegir'; sum.classList.toggle('q-empty', !v); }
  $$('[data-from-chip]').forEach(function (c) { c.classList.toggle('is-on', v.indexOf(c.dataset.fromChip) === 0); });
  var blk = $('[data-need="from"] .q-from'); if (blk && fromOk()) blk.classList.remove('q-bad');
  clearMsg('from');
}
function fromOk() { return !!from && from.value.trim().length >= 3; }
if (from) {
  from.addEventListener('input', function () { setFrom(from.value); });
  from.addEventListener('change', function () { setFrom(from.value); });
  $$('[data-from-chip]').forEach(function (c) {
    c.addEventListener('click', function () { from.value = c.dataset.fromChip; setFrom(from.value); });
  });
}

/* Presupuesto y pago a plazos */
var range = $('[data-budget]');
if (range) range.addEventListener('input', function () { budgetTouched = true; clearMsg('budget'); });
function pagoOk() { return !!form.querySelector('input[name="contact[Pago a plazos]"]:checked'); }
$$('input[name="contact[Pago a plazos]"]').forEach(function (r) { r.addEventListener('change', function () { clearMsg('pago'); }); });

/* Mensajes */
function blockOf(key) {
  if (key === 'from') return $('[data-need="from"]');
  if (key === 'budget') return range && range.closest('.q-block');
  if (key === 'pago') { var r = form.querySelector('input[name="contact[Pago a plazos]"]'); return r && r.closest('.q-block'); }
  return null;
}
function clearMsg(key) { var b = blockOf(key); if (!b) return; var m = b.querySelector('.q-need-msg'); if (m) m.remove(); }
function complain(key, text) {
  var b = blockOf(key); if (!b) return;
  var m = b.querySelector('.q-need-msg');
  if (!m) { m = document.createElement('p'); m.className = 'q-need-msg'; m.setAttribute('role', 'alert'); b.appendChild(m); }
  m.textContent = text;
  b.classList.remove('q-need-bad'); void b.offsetWidth; b.classList.add('q-need-bad');
  if (key === 'from') { var f = b.querySelector('.q-from'); if (f) f.classList.add('q-bad'); }
  var info = $('[data-foot-info]'); if (info) info.textContent = text;
}
function step2Missing() {
  if (!fromOk()) return ['from', 'Dinos desde qué ciudad o aeropuerto sales'];
  if (!budgetTouched) return ['budget', 'Mueve la barra para indicarnos tu presupuesto por persona'];
  if (!pagoOk()) return ['pago', 'Dinos si te interesa pagar a plazos'];
  return null;
}
function panel2Open() { var p = $('[data-panel="2"]'); return p && !p.hidden; }

/* «Continuar» en el paso 2: no avanza sin los datos */
var next = $('[data-next]');
if (next) next.addEventListener('click', function (e) {
  if (!panel2Open()) return;
  var miss = step2Missing();
  if (!miss) return;
  e.preventDefault(); e.stopImmediatePropagation();
  complain(miss[0], miss[1]);
  var b = blockOf(miss[0]); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (miss[0] === 'from' && from) setTimeout(function () { from.focus({ preventScroll: true }); }, 300);
}, true);

/* Envío: todo relleno, datos con sentido y freno a bots */
var NAME = /^[A-Za-zÀ-ÖØ-öø-ÿ' .-]{2,}$/;
function mark(el, bad) { var w = el && el.closest('.q-fl, .q-cb'); if (w) w.classList.toggle('q-bad', bad); }
function gate(e) {
  var hp = form.querySelector('[data-hp]');
  var bot = (hp && hp.value) || (Date.now() - loaded < 6000) || touches < 3;
  if (bot) { e.preventDefault(); e.stopImmediatePropagation(); return; }
  var miss = step2Missing();
  if (miss) {
    e.preventDefault(); e.stopImmediatePropagation();
    var back = $('[data-back]'); if (back && !panel2Open()) back.click();
    setTimeout(function () { complain(miss[0], miss[1]); }, 50);
    return;
  }
  var bad = [];
  ['#gtq-nom', '#gtq-ape'].forEach(function (s) { var el = root.querySelector(s); if (el && !NAME.test(el.value.trim())) bad.push(el); });
  var cp = root.querySelector('#gtq-cp'); if (cp && cp.value.trim().replace(/\s/g, '').length < 3) bad.push(cp);
  var tel = root.querySelector('#gtq-tel'); if (tel && tel.value.replace(/\D/g, '').length < 7) bad.push(tel);
  ['#gtq-nom', '#gtq-ape', '#gtq-cp', '#gtq-tel'].forEach(function (s) { var el = root.querySelector(s); if (el) mark(el, bad.indexOf(el) > -1); });
  if (bad.length) {
    e.preventDefault(); e.stopImmediatePropagation();
    bad[0].focus();
    var info = $('[data-foot-info]'); if (info) info.textContent = 'Revisa los campos marcados en rojo';
    return;
  }
  if (hidden && from) hidden.value = from.value.trim();
  store(from ? from.value.trim() : '');
}
/* Se comprueba al pulsar «Enviar» (y con Enter), antes de la verificación antirobots de Shopify */
root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-submit]')) gate(e); }, true);
root.addEventListener('submit', function (e) { if (e.target === form) gate(e); }, true);
/* El nombre completo se mantiene siempre al día */
var fullName = form.querySelector('[data-f="name"]');
function syncName() { var n = root.querySelector('#gtq-nom'), a = root.querySelector('#gtq-ape'); if (fullName && n) fullName.value = (n.value.trim() + ' ' + (a ? a.value.trim() : '')).trim(); }
['#gtq-nom', '#gtq-ape'].forEach(function (s) { var el = root.querySelector(s); if (el) el.addEventListener('input', syncName); });
})();
